// extracted by mini-css-extract-plugin
module.exports = {"heading":"login_heading__25d1H","title":"login_title__3fuJr"};